import React, { Component } from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { modules, linkOption } from './contants';

class RichTextArea extends Component {

  state = {
    text: ''
  };

  componentDidMount () {
    this.setState({ text: this.props.value})
  }

  handleChange = (value) => {
    this.setState({ text: value }, () => {
      this.props.onRichTextChange(value);
    })
  }

  render() {
    return(
      <div className="rich-text-container">
        <ReactQuill 
          value={this.state.text} 
          onChange={this.handleChange} 
          modules={ (this.props.linkOption ? linkOption : modules) } />
      </div>
    )
  }
}

export default RichTextArea



// WEBPACK FOOTER //
// ./src/app/components/baseComponents/RichTextArea/index.js